/* 学生处 */
export const studentDepartmentRouter = [
  {
    path: '/studentDepartment/greenRoad',
    name: 'greenRoad',
    component: () => import('@/views/pages/studentDepartment/greenRoad.vue'),
    meta: {
      title: '绿色通道',
      role: ['超级管理员']
    }
  },
  {
    path: '/studentDepartment/uniformCard',
    name: 'uniformCard',
    component: () => import('@/views/pages/studentDepartment/uniformCard.vue'),
    meta: {
      title: '校服与校园卡登记',
      role: ['超级管理员']
    }
  },
  {
    path: '/studentDepartment/schoolCoatCount',
    name: 'schoolCoatCount',
    component: () => import('@/views/pages/studentDepartment/schoolCoatCount.vue'),
    meta: {
      title: '校服统计',
      role: ['超级管理员']
    }
  },
  {
    path: '/studentDepartment/snookerRoom',
    name: 'snookerRoom',
    component: () => import('@/views/pages/studentManage/snooker-room/SnookerRoom.vue'),
    meta: {
      title: '桌球室管理',
      role: ['超级管理员']
    }
  },
  {
    path: '/studentDepartment/snookerSchedule',
    name: 'SnookerSchedule',
    component: () => import('@/views/pages/studentManage/snooker-schedule/SnookerSchedule.vue'),
    meta: {
      title: '桌球室排期',
      role: ['超级管理员']
    }
  },
  {
    path: '/studentDepartment/snookerOrderRecord',
    name: 'SnookerOrderRecord',
    component: () => import('@/views/pages/studentManage/snooker-order-record/SnookerOrderRecord.vue'),
    meta: {
      title: '桌球室预约记录',
      role: ['超级管理员']
    }
  },
  {
    path: '/studentDepartment/snookerBlockList',
    name: 'SnookerBlockList',
    component: () => import('@/views/pages/studentManage/snooker-block-list/SnookerBlockList.vue'),
    meta: {
      title: '桌球室黑名单',
      role: ['超级管理员']
    }
  }
]
